export const MAX_CONTENT_WIDTH = '1616px';
//# sourceMappingURL=constants.js.map